import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        // 배지는 꽉 찬 색을 쓰지 않는다 - 기본도 브랜드의 옅은 짝이다(10-04 사용자 「이 정도 채도는 배지/태그에 잘 안 쓴다」).
        default:
          'border-primary-subtle-border bg-primary-subtle text-primary-subtle-foreground',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        /*
         * 뜻을 가진 배지 (2026-09-20). 본문 옆에 앉는 칸이라 꽉 찬 바탕 대신
         * 옅은 바탕 + 진한 글자를 쓴다 — 제목보다 시끄러우면 안 된다.
         * 화면에서 `border-emerald-200 bg-emerald-50 ...` 를 손으로 적지 않는다.
         */
        success:
          'border-success-subtle-border bg-success-subtle text-success-subtle-foreground',
        warning:
          'border-warning-subtle-border bg-warning-subtle text-warning-subtle-foreground',
        info:
          'border-primary-subtle-border bg-primary-subtle text-primary-subtle-foreground',
        progress:
          'border-progress-subtle-border bg-progress-subtle text-progress-subtle-foreground',
        danger:
          'border-destructive-subtle-border bg-destructive-subtle text-destructive-subtle-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
